import { withUtcOffsetInLabel } from './timezoneOffsetLabel';

export type HeatmapTimezoneRegion = {
  value: string;
  label: string;
};

export type HeatmapTimezoneCountry = {
  value: string;
  label: string;
  regions: readonly HeatmapTimezoneRegion[];
};

/**
 * IANA zones allowed by tipmi-admin-api PostHogProxyService.HEATMAP_TIMEZONES.
 * Second step is state (AU) or timezone region (US).
 */
export const HEATMAP_TIMEZONE_COUNTRIES: readonly HeatmapTimezoneCountry[] = [
  {
    value: 'AU',
    label: 'Australia',
    regions: [
      { value: 'Australia/Melbourne', label: 'Victoria' },
      { value: 'Australia/Sydney', label: 'New South Wales' },
      { value: 'Australia/Brisbane', label: 'Queensland' },
      { value: 'Australia/Adelaide', label: 'South Australia' },
      { value: 'Australia/Perth', label: 'Western Australia' },
    ],
  },
  {
    value: 'US',
    label: 'United States',
    regions: [
      { value: 'America/New_York', label: 'Eastern' },
      { value: 'America/Chicago', label: 'Central' },
      { value: 'America/Denver', label: 'Mountain' },
      { value: 'America/Los_Angeles', label: 'Pacific' },
    ],
  },
];

export const DEFAULT_ENGAGEMENT_TIMEZONE = 'Australia/Melbourne';
export const DEFAULT_DASHBOARD_TIMEZONE = 'Australia/Sydney';

/** Flat IANA list for callers that only need values. */
export const HEATMAP_TIMEZONES = HEATMAP_TIMEZONE_COUNTRIES.flatMap((country) =>
  country.regions.length > 0
    ? country.regions.map((region) => ({
        value: region.value,
        label: `${country.value} - ${region.label}`,
      }))
    : [{ value: country.value, label: country.label }],
);

export function heatmapTimezoneCountry(timezone: string): HeatmapTimezoneCountry | undefined {
  return HEATMAP_TIMEZONE_COUNTRIES.find((country) =>
    country.regions.length === 0
      ? country.value === timezone
      : country.regions.some((region) => region.value === timezone),
  );
}

export function heatmapTimezoneClosedLabel(timezone: string, at: Date = new Date()): string {
  const country = heatmapTimezoneCountry(timezone);
  if (!country) return timezone;
  if (country.regions.length === 0) return country.label;
  const region = country.regions.find((item) => item.value === timezone);
  if (!region) return timezone;
  return withUtcOffsetInLabel(`${country.label} — ${region.label}`, timezone, at);
}
